class SiteHeader extends HTMLElement {
  connectedCallback() {
    // Get the "location" aka which handbook we're looking at.
    const location = window.getHandbookLocation();

    // Define Main Handbook Header HTML
    const handbookHeaderHtml = /*html */ `
<header class="iowa-bar iowa-bar--narrow" data-uids-header="" id="header">
  <div class="iowa-bar__container">
    <div class="logo logo--tab">
      <a href="https://uiowa.edu">
        <div class="element-invisible">University of Iowa</div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="logo-icon"
          aria-labelledby="logo-header"
          role="img"
          viewBox="0 0 311.6 90.2"
        >
          <path
            class="st0"
            d="M40 18.8h-7.3v52.4H40v19H0v-19h7.3V18.8H0V0h40V18.8z"
          ></path>
          <path
            class="st0"
            d="M93.8 90.2h-29c-10.5 0-17.4-6.9-17.4-18.2V18.2C47.4 7 54.4 0 64.8 0h29c10.5 0 17.4 7 17.4 18.2V72C111.2 83.2 104.2 90.2 93.8 90.2zM85.6 71.2V18.8H73v52.4H85.6z"
          ></path>
          <path
            class="st0"
            d="M122.6 18.8h-6.4V0h38v18.9H147l6.5 43.4L167 0h19.2l14.4 62.3 5.2-43.4h-6.6V0h37.5v18.9h-6.2l-11.3 71.4h-30.6l-11.8-53.2 -12.1 53.1h-29.4L122.6 18.8z"
          ></path>
          <path
            class="st0"
            d="M230.1 71.2h6.9L250.7 0h41l13.5 71.2h6.4v19H281l-2.9-22h-15.2l-2.7 22h-30L230.1 71.2 230.1 71.2zM276.5 51.7l-5.8-36.4 -6 36.4H276.5z"
          ></path>
          <image src="../../assets/images/uiowa-primary.png">
            <title id="header-logo">University of Iowa</title>
          </image>
        </svg>
      </a>
    </div>
    <div class="parent-site-name"><a href="https://pathology.medicine.uiowa.edu">Department of Pathology</a></div>
  </div>
  <div class="iowa-bar__below">
    <div class="iowa-bar__container">
      <h1 class="site-name"><a href="/path_handbook/">Laboratory Services Handbook</a></h1>
      <site-search class="site-search-header"></site-search>
    </div>
  </div>
</header>
<az-nav></az-nav>`;

    // Define UIDL Header HTML
    const uidlHeaderHtml = /*html */ `
    <div id="header" class="hb-header">
    <div class="hb-header-flex">
        <div>
              <a href="/path_handbook/rindex.html" class="hb-header-logo-container"><img class="hb-header-uidl-logo" width="267" src="/path_handbook/assets/images/uidl-logo.svg" alt="UIDL Logo" /><span class="hb-header-logo-text">Test Directory</span></a>
        </div>
        <div class="hb-header-contact-container">
          <p>
          <a href="https://uidl.medicine.uiowa.edu/about-us/contact-and-availability" target="_blank">Contact &amp; Availability</a><br />

          <a href="https://uidl.medicine.uiowa.edu/" target="_blank">UIDL Website</a>
          
          </p>
        </div>
          <div class="hb-header-search-container">
              <site-search></site-search>
          </div>
        </div>
        <az-nav></az-nav>
    </div>

    `;

    // Define Off-Campus Header HTML
    const ocHeaderHtml = /*html */ `
        <div id="header" class="hb-header">
            <table width="85%">
                <tr>
                    <td>
                        The University of Iowa<br>
                        Department of Pathology<br>
                        Laboratory Services Handbook<br />
                        Off-Campus Locations
                    </td>
                    <td>
                        <br>
                    </td>
                    <td align="right" valign="middle">
                        <site-search></site-search>
                    </td>
                </tr>
            </table>
        </div>
        `;
    document.body.classList.add("location-" + location);
    // Determine and use the appropriate header based on the handbook we're looking at.
    switch (location) {
      case 1:
        this.innerHTML = handbookHeaderHtml;
        break;
      case 2:
        this.innerHTML = ocHeaderHtml;
        break;
      case 4:
        this.innerHTML = uidlHeaderHtml;
        break;
      default:
        this.innerHTML = handbookHeaderHtml;
        break;
    }
  }

  //Function to determine if we're on one of the handbooks' homepages.
  isHomePage() {
    const url = window.location.pathname;
    const homePages = ["/path_handbook/", "/path_handbook/index.html", "/path_handbook/rindex.html", "/path_handbook/ocindex.html"];
    for (const homePage of homePages) {
      if (url == homePage) {
        return true;
      }
    }
    return false;
  }

  //Function to determine if we're on one of the handbooks' test pages.
  isTestPage() {
    const url = window.location.pathname;
    const testFileDirectories = ["/handbook/", "/rhandbook/", "/ochandbook/"];
    for (const testFileDirectory of testFileDirectories) {
      if (url.includes(testFileDirectory)) {
        return true;
      }
    }
    return false;
  }
}
customElements.define("site-header", SiteHeader);
